import RoleHome from '../RoleHome';

export default function PharmacistPage() {
  return (
    <RoleHome
      title="Pharmacist"
      description="Prescriptions, inventory, and referrals."
    />
  );
}
